define(['jquery', 'matchMedia'], () => {
    return query => {
        const mobileQuery = `(max-width: ${window.maxMobile}px)`;
        const tabletQuery = `(min-width: ${window.minTablet}px) and (max-width: ${window.maxTablet}px)`;
        const desktopSmallQuery = `(min-width: ${window.maxTablet}px) and (max-width: ${window.maxDesktopSmall}px)`;
        const desktopQuery = `(min-width: ${window.minDesktop}px)`;
        const mobile = window.matchMedia(mobileQuery).matches;
        const tablet = window.matchMedia(tabletQuery).matches;
        const desktopSmall = window.matchMedia(desktopSmallQuery).matches;
        const desktop = window.matchMedia(desktopQuery).matches;

        if (query) {
            return window.matchMedia(query).matches;
        }

        return {
            mobile,
            tablet,
            desktopSmall,
            desktop,
        };
    };
});
